import * as React from 'react'
import * as UI from '@brewlogix/blx-ui'

// Constants
import { LocationHighlight } from 'src/types/schema/graphql'
import tailwindConfig from '@brewlogix/blx-ui/tailwind.config'
import { useRouter } from 'next/router'
import { parseEnumLabel } from 'src/util/helpers'
import { getOption } from '../../utils/helpers'

interface IHighlights {
    highlights: LocationHighlight[]
}

const Highlights: React.FC<IHighlights> = ({ highlights }) => {
    const router = useRouter()
    const icons = Object.keys(tailwindConfig.theme.icons)
    const noDataTitle = 'Highlights coming soon...'

    return (
        <>
            <div className='space-y-6'>
                <UI.Heading
                    text='Highlights'
                    size='h4'
                    type='h2'
                    customClasses='text-xl lg:text-2xl'
                />
                {highlights.length === 0 && <div className='flex'>{noDataTitle}</div>}
                <div className='mt-4 grid grid-cols-2 flex-row flex-wrap items-baseline gap-3'>
                    {highlights.map((a) => {
                        const iconExists = icons.includes(getOption(a?.description?.toString()))
                        return (
                            <div
                                key={`cell-${a.description}`}
                                className='flex flex-wrap justify-start gap-2'
                            >
                                {iconExists ? (
                                    <UI.Pill
                                        icon={`${getOption(a?.description?.toString())}`}
                                        iconAlignment='left'
                                        theme='default'
                                        shape='full'
                                        label={parseEnumLabel(a?.description)}
                                        size='lg'
                                        customClasses='border-0 bg-transparent -ml-3'
                                    />
                                ) : (
                                    <UI.Pill
                                        theme='default'
                                        shape='full'
                                        label={parseEnumLabel(a?.description)}
                                        size='lg'
                                        customClasses='border-0 bg-transparent -ml-3'
                                    />
                                )}
                            </div>
                        )
                    })}
                </div>
                <UI.Button
                    size='sm'
                    label='View all amenities'
                    onClick={() => router.push('#amenities')}
                />
            </div>
        </>
    )
}

export default Highlights
